import { lazy } from 'react';

export default {
  ui: 'menuHelp',
  path: 'contact',
  title: 'Contact',
  component: lazy(() => import('./index')),
};
